import React from "react";
import { FieldValues } from "react-hook-form";

import FormGenerator from "../../form/FormGenerator";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";

export type DeviceTypeManagementFormValues = {
  label: string;
  type: string;
};

interface Props {
  defaultValues: FieldValues;
  handleSubmit: (form_values: DeviceTypeManagementFormValues) => void;
  loading?: boolean;
}
const DeviceTypeManagementForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false }) => {
  const fields: FormFieldType[] = [
    { type: FormFieldTypesAllowed.Textfield, label: "Label", id: "label", required: "Field is required" },
    { type: FormFieldTypesAllowed.Textfield, label: "Type", id: "type", required: "Field is required" },
  ];
  return (
    <FormGenerator
      defaultValues={defaultValues}
      formFields={fields}
      handleFormSubmit={handleSubmit}
      className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
      loading={loading}
    />
  );
};

export default DeviceTypeManagementForm;
